import { render, staticRenderFns } from "./TileData.vue?vue&type=template&id=6349315c&"
import script from "./TileData.vue?vue&type=script&lang=js&"
export * from "./TileData.vue?vue&type=script&lang=js&"
import style0 from "./TileData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports